// extracted by mini-css-extract-plugin
export default {"button":"ShowImportantMessages_button__vDef8","modal":"ShowImportantMessages_modal__7gRyu"};